import { AUTH_USER_ACTIONS } from 'Actions/index';
import { APP_ROUTES } from 'Utils/appShell';
import { AUTH_STATES, REQUEST_TYPES } from 'Utils/constants';

const initialState = {
  customerId: '',
  accountId: '',
  userProfile: {
    email: '',
    firstName: '',
    lastName: '',
    username: '',
    role: '',
  },
  accountServices: [
    REQUEST_TYPES.MOVE,
    REQUEST_TYPES.AIRPORT_TRANSFER,
    REQUEST_TYPES.SHORT_STAY,
    REQUEST_TYPES.TICKET,
    REQUEST_TYPES.HOUSING,
    REQUEST_TYPES.SETTLING_IN,
  ],
  enableBudget: true,
  userAuthState: AUTH_STATES.SIGNED_OUT,
  redirectPathPostSignIn: APP_ROUTES.ROOT,
};

const {
  SET_LOGGED_IN_USER_DETAILS,
  SET_REDIRECT_PATH,
  SET_AUTH_STATE,
  SET_ACCOUNT_SETTINGS,
} = AUTH_USER_ACTIONS;

const authUser = (state = initialState, action) => {
  switch (action.type) {
    case SET_REDIRECT_PATH:
      const redirectPath =
        action.payload.redirectPath || initialState.redirectPathPostSignIn;
      return {
        ...state,
        redirectPathPostSignIn: redirectPath,
      };
    case SET_AUTH_STATE:
      return {
        ...state,
        userAuthState: action.payload.authState,
      };
    case SET_LOGGED_IN_USER_DETAILS:
      sessionStorage.userRole = action.payload.appRole;
      return {
        ...state,
        accountId: action.payload.accountId,
        customerId: action.payload.customerId,
        userProfile: {
          email: action.payload.email,
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
          username: action.payload.username,
          role: action.payload.appRole,
        },
      };
    case SET_ACCOUNT_SETTINGS:
      return {
        ...state,
        accountServices: action.payload.accountServices,
        enableBudget: action.payload.enableBudget,
      };
    default:
      return state;
  }
};

export default authUser;
